module.exports = __webpack_public_path__ + "img/item2.983d7021.png";